import axios from 'axios';
import { getApiUrl } from '../constants/api';

interface LoggedInConversionParams {
  storeType: string;
  sessionId: string;
  storeId: number;
  customerId: string | undefined;
}

export async function loggedInCoversion({
  sessionId,
  storeType,
  storeId,
  customerId,
}: LoggedInConversionParams) {
  return await axios.post(
    `${getApiUrl(
      `${storeId}`,
    )}/stores/${storeId}/analytics/customer-login?storeType=${storeType}`,
    { sessionId, customerId },
  );
}
